"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var tv4 = require('tv4');

var InventoryReference = /*#__PURE__*/function () {
  function InventoryReference(opt) {
    _classCallCheck(this, InventoryReference);

    this._id = null;
    this.tenantCode = '';
    this.campusCode = '';
    this.name = '';
    this.stockroom = false;

    if (opt) {
      this.fillObject(opt);
    }
  }

  _createClass(InventoryReference, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.tenantCode = opt.tenantCode;
      this.campusCode = opt.campusCode;
      this.name = opt.name;
      this.stockroom = !!opt.stockroom;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, InventoryReference.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'inventory-reference.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'object'
          },
          tenantCode: {
            type: 'string'
          },
          campusCode: {
            type: 'string'
          },
          name: {
            type: 'string'
          },
          stockroom: {
            type: 'boolean'
          }
        },
        required: ['_id', 'name', 'tenantCode', 'campusCode']
      };
    }
  }]);

  return InventoryReference;
}();

module.exports = InventoryReference;